import { Component, OnInit, ViewChild } from '@angular/core';
import { OwlCarousel } from 'ngx-owl-carousel';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {
  categories: any;
  categories2:any;
  openCategory:boolean;
  @ViewChild('owlElement') owlElement: OwlCarousel;

  constructor() {
    this.categories = environment.categoriesModel;
    this.categories2=environment.categories2Model;
  }

  ngOnInit() {
  }
  viewAll(){
    this.openCategory=true;
  }
  hideAll()
{
  this.openCategory=false;
}
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/welcome-page/categories/categories.component.ts